import SweetAlert from 'react-bootstrap-sweetalert';
import { useNavigate } from 'react-router-dom';
import './PaymentSuccess.css';
export default function PaymentSuccess() {

    const navigate = useNavigate();
    const onConfirm = () => {
        localStorage.removeItem("cashew/carts");
        navigate('/')
    }
    const onCancel = () => {
        console.log('Cancel')
    }
    return (
        <SweetAlert confirmBtnText="Go to Home" success title="Congratulation!" onConfirm={onConfirm} onCancel={onCancel}>
            Your Order is Submitted.
        </SweetAlert>
    )
}
